import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';

interface ViewGoalCreatorProps {
  creator: FullIssueWithChildren['issueCreator'];
  createdAt: string;
}

export const ViewGoalCreator: React.FC<ViewGoalCreatorProps> = ({
  creator,
  createdAt,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 block">
        {t('creatorLabel')}
      </label>
      <div className="flex items-center gap-3">
        <UserSelectorAvatar
          fullName={`${creator.personalInfo.firstName} ${creator.personalInfo.lastName}`}
          imageUrl={creator.personalInfo.imageUrl}
          size="md"
        />
        <div>
          <p className="text-sm font-medium text-gray-900">
            {creator.personalInfo.firstName} {creator.personalInfo.lastName}
          </p>
          <p className="text-xs text-gray-500">
            {new Date(createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
